// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instance-metrics[data-v-266e90cc]:hover {\n  cursor: pointer;\n}\n.even[data-v-266e90cc] {\n  background-color: #fafafa;\n}\n.warning-text[data-v-266e90cc] {\n  color: #f59d34;\n}\n.grayed-text[data-v-266e90cc] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
